<template>
  <div class="main_div">
    <div class="row" v-if="deals.length">
      <div class="col-md-2"><label for="">Валюта</label></div>
      <div class="col-md-2"><label for="">Количество</label></div>
      <div class="col-md-2"><label for="">Курс</label></div>
      <div class="col-md-2"><label for="">На сумму</label></div>
    </div>

    <div class="row currencyLine" v-for="(detail, index) in deals">
      <div class="col-md-2">
        <input readonly type="text" class="form-control" v-model="detail.title"/>
      </div>
      <div class="col-md-2">
        <input type="number" @keyup="updateExchange($event, index, 'sum')" v-model="detail.sum" class="form-control">
      </div>
      <div class="col-md-2">
        <input type="number" @keyup="updateExchange($event, index, 'displayRate')" v-model="detail.displayRate" class="form-control">
      </div>
      <div class="col-md-2">
        <input type="number" @keyup="updateExchange($event, index, 'total')" v-model="detail.total" class="form-control">
      </div>
      <div class="col-md-2">
        <div class="form-check">
          <input class="form-check-input" v-model="detail.saveRate" type="checkbox" :id="`gridCheck_${index}`">
          <label class="form-check-label pointer" :for="`gridCheck_${index}`">
            сохранить курс
          </label>
        </div>
      </div>
    </div>

    <div class="flex flex-jc-between">
      <div>
        <div class="input-group">
          <select class="custom-select" v-model="newCurrencyId">
            <option disabled value="0">Выберите валюту</option>
            <option v-for="(currency, id) in allowToBuy" :value="id">{{currency}}</option>
          </select>
          <div class="input-group-append">
            <button @click="addExpense" class="btn btn-sm btn-info">Купить валюту</button>
          </div>
        </div>
      </div>
      <vue-ladda @click="saveExchange" button-class="btn btn-sm btn-success"
                 data-style="zoom-in"
                 :loading="btnLoading">Сохранить валюты
      </vue-ladda>
    </div>
  </div>
</template>

<script>

  import api from '@/api'
  import VueLadda from 'vue-ladda/src/vue-ladda.vue'

  export default {
    components: {
      VueLadda
    },
    props: ['currenciesDeals', 'currencies', 'date', 'userId'],
    data() {
      return {
        allowedCurrencies: {},
        newCurrencyId: 0,
        allowToBuy: [],
        deals: [],
        btnLoading: false,
        type: 0,
      }
    },
    mounted() {
      this.allowedCurrencies = {...this.currencies};
      this.deals = [...this.currenciesDeals];
      this.filterCurrencies();
      this.updateAllowToBuy();
      this.updateExchange();
    },
    methods: {
      filterCurrencies() {
        delete this.allowedCurrencies[33];
      },
      updateAllowToBuy() {
        this.allowToBuy = {...this.allowedCurrencies};
        this.deals.forEach((d) => {
          delete this.allowToBuy[d.currency_id];
        })
        this.newCurrencyId = 0;
      },
      updateExchange(e = null, index = null, title = null) {
        if (!e){
          this.deals.forEach((ex) => {
            if (!ex.title) ex.title = this.allowedCurrencies[ex.currency_id];
            ex.total = Math.round((ex.sum ? ex.sum : 0) / (ex.rate ? ex.rate : 0));
            ex.displayRate = Math.round(ex.total / ex.sum * 10000) / 10000;
          })
          return;
        }
        const exchange = {...this.deals[index]};
        switch (title) {
          case 'displayRate':
            exchange.total = (+exchange.sum * +exchange.displayRate).toFixed(2);
            exchange.rate = +exchange.sum / +exchange.total;
            break;
          case 'sum':
            exchange.total = (+exchange.sum * +exchange.displayRate).toFixed(2);;
            break;
          case 'total':
            exchange.rate = +exchange.sum / +exchange.total;
            exchange.displayRate = Math.round(+exchange.total / +exchange.sum * 10000) / 10000;
            break;
        }
        this.deals[index] = {...exchange};
        this.deals = [...this.deals];
      },
      addExpense(){

        if (!this.newCurrencyId) return;

        this.deals.push({
          id: null,
          title: this.allowedCurrencies[this.newCurrencyId],
          total: 0,
          saveRate: true,
          currency_id: this.newCurrencyId,
          rate: 0,
          displayRate: 0,
          sum: 0
        })

        this.updateAllowToBuy();

      },
      async saveExchange(){
        this.btnLoading = true;
        const {data} = await api.post('/reports/updateExchange', {
          deals: this.deals,
          user_id: this.userId,
          date: this.date
        });
        if (data.success){
          toastr['success']('Сохранено');
          this.deals = data.exchanges;
          this.updateExchange();
        } else {
          toastr['warning'](data.message || 'Ошибка');
        }
        this.btnLoading = false;
      }
    }
  }

</script>

<style scoped>
  .currencyLine label{
    margin-bottom: 1px;
  }
  .currencyLine{
    padding-bottom: 3px;
  }
  .expense.deleted{
    opacity: .3;
  }
  .main_div{
    padding-bottom: 15px;
  }
  .main_expenses {
    padding: 15px;
    padding-top: 0;
  }

  .expense div {
    padding: 0;
  }

  .expense input,
  .expense .btn,
  .expense select {
    border-radius: 0;
  }

</style>
